interface ManagerEntry {
  staff: { id: string; firstName: string; surname: string; photoBusiness?: string | null };
}

interface ManagersCellProps {
  managers?: ManagerEntry[];
}

export function ManagersCell({ managers }: ManagersCellProps) {
  if (!managers || managers.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {managers.map(({ staff }) => (
        <span
          key={staff.id}
          className="inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium"
        >
          {staff.firstName} {staff.surname}
        </span>
      ))}
    </div>
  );
}
